/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dropdown from 'react-bootstrap/lib/Dropdown';

import { PAGES__SHAPE_ARRAY } from '../../../../redux/constants';
import { navItemCss, labelCss } from './nav.style';

export default function ClientNavItem(props) {
  const { pageIndex, pages } = props;
  return (
    <Dropdown css={navItemCss({ dropdown: true })} id="ClientNavDropdown">
      <Dropdown.Toggle noCaret className="nav-item__toggle">
        <div css={labelCss()}>
          <span className="fa fa-ellipsis-h" />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="nav-item__menu">
        <li className="nav-item__menu-label">
          Slide {pageIndex + 1} of {pages.length}
        </li>
        {pages.map((page, key) => (
          <li
            className={classNames(
              'nav-item__menu-item',
              key === pageIndex && 'nav-item__menu-item--active',
            )}
            key={page.id}
          >
            {key + 1}
          </li>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

ClientNavItem.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  pages: PAGES__SHAPE_ARRAY.isRequired,
};
